"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibility = void 0;
require("./visibility.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const visibility = {
  hidden: "cds-hidden-h14vwkni",
  visible: "cds-visible-vk07kfy"
};
exports.visibility = visibility;